/**
 * Toasts (spec §9.19 no-surprises): nothing disappears in under 8 s, nothing moves content, and a
 * destructive action shows a 10 s undo toast instead of a confirmation dialog (§9.24).
 */
import { create } from "zustand";

export interface Toast {
  id: number;
  text: string;
  action?: { label: string; run(): void };
  until: number;
}

interface ToastState {
  toasts: Toast[];
  push(text: string, opts?: { action?: Toast["action"]; ms?: number }): number;
  dismiss(id: number): void;
}

let seq = 0;

export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  push(text, opts = {}) {
    const id = ++seq;
    const ms = Math.max(8000, opts.ms ?? (opts.action ? 10_000 : 8000));
    set({ toasts: [...get().toasts, { id, text, action: opts.action, until: Date.now() + ms }] });
    setTimeout(() => get().dismiss(id), ms);
    return id;
  },
  dismiss(id) {
    set({ toasts: get().toasts.filter((t) => t.id !== id) });
  },
}));
